const PREFIX = 'EMPLOYEE_PERMISSION_';

export const EMPLOYEE_PERMISSION_PAGE_REQUEST = `${PREFIX}PAGE_REQUEST`;

export const EMPLOYEE_PERMISSION_SUBMIT_FORM = `${PREFIX}SUBMIT_FORM`;

export const EMPLOYEE_PERMISSION_SET_SETTING = `${PREFIX}SET_SETTING`;

export const EMPLOYEE_PERMISSION_CHANGE_PAGE = `${PREFIX}CHANGE_PAGE`;
